export const BONUS_ERROR_MESSAGES: Record<string, string> = {
  'bonus.availability.channel_inactive':
    'Este QR não está mais disponível para reserva.',
  'bonus.availability.no_visible_partner':
    'Este bônus não está mais disponível para reserva.',
  'bonus.availability.not_active':
    'Este bônus não está ativo no momento.',
  'bonus.redemption.stock_exhausted':
    'O estoque deste bônus já foi esgotado.',
  'bonus.redemption.limit_reached':
    'Você já atingiu o limite de reservas deste bônus.',
  'bonus.not_found': 'Bônus não encontrado.'
}

export const getBonusErrorMessage = (code?: string) =>
  (code && BONUS_ERROR_MESSAGES[code]) ||
  'Não foi possível concluir a reserva deste bônus.'
